import { useEffect, useCallback, useRef } from 'react';
import { setupOAuthCallback } from '../utils/oauthHelper';

interface OAuthConfig {
  weburl: string;
  apiAuthURL: string;
  clientId: string;
}

export const useOAuth = (
  config: OAuthConfig,
  tenancyName: string,
  currentTab: number,
  onSuccess: (data: Record<string, string>) => void,
  onError?: (error: Error) => void,
  onCancel?: () => void,
) =>
{
  const callbackFiredRef = useRef(false);

  useEffect(() =>
  {
    setupOAuthCallback(data =>
    {
      callbackFiredRef.current = true;
      if (data.error)
      {
        onError?.(new Error(data.error_description || data.error));
      }
      else
      {
        onSuccess(data);
      }
    });
  }, [onSuccess, onError]);

  const loginWithProvider = useCallback(
    (provider: string) =>
    {
      const base = (import.meta.env.VITE_BASE_URL || '/').replace(/\/$/, '');
      const redirectUri = `${window.location.origin}${base}/authcomplete.html`;

      const endpoint = currentTab === 1 ? 'ExternalLogin' : 'RegisterExternalLogin';

      const authUrl = `${config.apiAuthURL}api/Account/${endpoint}?provider=${provider}&clientId=Corgee&redirectUri=${encodeURIComponent(redirectUri)}&tenancyName=${tenancyName}`;

      callbackFiredRef.current = false;

      const oauthWindow = window.open(
        authUrl,
        'Authenticate Account',
        'location=0,status=0,width=600,height=750',
      );

      if (!oauthWindow || oauthWindow.closed)
      {
        onError?.(new Error('La ventana popup fue bloqueada'));
        return;
      }

      const pollTimer = setInterval(() =>
      {
        if (oauthWindow.closed)
        {
          clearInterval(pollTimer);
          if (!callbackFiredRef.current)
          {
            onCancel?.();
          }
        }
      }, 500);
    },
    [config, currentTab, tenancyName, onError, onCancel],
  );

  return { loginWithProvider };
};
